<template>
  <div>
    <b-card
      v-for="(item,key) in dataItem.featureList"
      :key="key"
      :title="item.title"
    >
      <b-row>
        <b-col
          v-for="(feature,fkey) in item.features"
          :key="fkey"
          cols="12"
          md="4"
        >
          <b-form-checkbox
            v-model="feature.status"
            :value="'1'"
          >
            {{ feature.title }}
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BRow, BCol, BFormCheckbox,
} from 'bootstrap-vue'

export default {
  name: 'ProductFeaturesForm',
  components: {
    BFormCheckbox,
    BCard,
    BRow,
    BCol,
  },
  computed: {
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
  },
}
</script>
